import { file_Uploaddata, Step_Action } from "../action/action";

const initialState = {
    fileUpload: {},
    stepValue: "0"
}
//reducers
const articleReducer = (state = initialState, action) => {
    switch (action.type) {
        case file_Uploaddata:
            return { ...state, fileUpload: action.fileUploaddata };
        case Step_Action:
            return { ...state, stepValue: action.stepCounter };
        default:
            return state;
    }
}
export default articleReducer;